/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Path_P1Inputs */

const en_guides_path_p1 = /** @type {(inputs: Guides_Path_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you are learning the format, read What is JSON, then Common Syntax Errors.
Together they cover the structure and the mistakes that structure invites.`)
};

const ko_guides_path_p1 = /** @type {(inputs: Guides_Path_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`형식을 익히는 단계라면 JSON이란 무엇인가를 읽고 이어서 구문 오류 편을 보세요.
두 편이 구조와 그 구조가 유발하는 실수를 함께 다룹니다.`)
};

const ja_guides_path_p1 = /** @type {(inputs: Guides_Path_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`形式を学ぶ段階なら、JSONとは何かを読み、続いて構文エラー編に進んでください。
この2編で構造と、その構造が招く間違いの両方を扱います。`)
};

/**
* | output |
* | --- |
* | "If you are learning the format, read What is JSON, then Common Syntax Errors. Together they cover the structure and the mistakes that structure invites." |
*
* @param {Guides_Path_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_path_p1 = /** @type {((inputs?: Guides_Path_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Path_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_path_p1(inputs)
	if (locale === "ko") return ko_guides_path_p1(inputs)
	return ja_guides_path_p1(inputs)
});